import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getToken } from "./Common";

// handle the public routes
function PublicRoute({ component: Component, ...rest }) {
  return (
    <Route
      render={(props) =>
        !getToken() ? (
          <Component {...rest} />
        ) : (
          <Redirect to={{ pathname: "/dashboard" }} />
        )
      }
    />
  );
}

export default PublicRoute;
